module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('ui-sidebar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2630f60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/provider/Scheduler.vue
// module id = 499
// module chunks = 0